/**
 * Query keys for TanStack Query
 */
export const EXTENSION_QUERY_KEYS = {
  all: ['extensions'] as const,
  lists: () => [...EXTENSION_QUERY_KEYS.all, 'list'] as const,
  list: (pbxId: number | undefined | null, params?: Record<string, unknown>) =>
    [...EXTENSION_QUERY_KEYS.lists(), pbxId, params ?? {}] as const,
  details: () => [...EXTENSION_QUERY_KEYS.all, 'detail'] as const,
  detail: (id: number | string) =>
    [...EXTENSION_QUERY_KEYS.details(), id] as const,
} as const
